import { useSignupStep } from '@/app/(auth)/signup/components/signupStep/SignupStepContext';
import React from 'react';
import { Alert } from '@common/bw-ui/ui/alert';

/**
 * Just shows the error message for the whole step - IE if we had a network error or something similar.
 *
 * This does not show the field-level error messages.
 * @constructor
 */
export function StepError() {
  const { error } = useSignupStep();

  if (!error) {
    return null;
  }

  return <Alert variant="error" title="Something went wrong" description={error} />;
}
